/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { CartItem, QuoteCartItem } from '../../cart/storage/cart.types';

export const mapCartProductsToQuoteProducts = (cartProducts: CartItem[]): QuoteCartItem[] =>
  cartProducts.map((cartProduct: CartItem) => ({
    itemId: cartProduct.itemNumber,
    quantity: cartProduct.quantity,
    basePriceExcGst: cartProduct.basePriceExcGst,
    basePriceIncGst: cartProduct.basePriceIncGst,
    category: cartProduct.category,
    name: cartProduct.name,
    description: cartProduct.description,
    discountedPriceExcGst: cartProduct.discountedPriceExcGst,
    discountedPriceIncGst: cartProduct.discountedPriceIncGst,
    itemNumber: cartProduct.itemNumber,
    lifeCycleState: cartProduct.lifeCycleState,
    masterProductId: cartProduct.masterProductId,
    orders: cartProduct.orders,
    productId: cartProduct.productId,
    editedPriceExcGst: cartProduct.editedPriceExcGst,
    lastEditedReasonCode: cartProduct.lastEditedReasonCode,
    lastEditedReasonNote: cartProduct.lastEditedReasonNote,
  }));
